module.exports = __webpack_public_path__ + "static/media/fa-light-300.a3702ff5.woff";